window.k1ScriptComments = {
	getData: function (event) {
		event.preventDefault();
		let data = {};
		let dataRequire = {
			name: document.querySelector('#REVIEW_GOOD_NAME').value,
			comment: document.querySelector('#REVIEW_GOOD_COMMENT').value,
			check: document.querySelector('.review-form__row-confirm input').checked
		};
		let error = false;
		let stars = document.querySelectorAll('#REVIEW_GOOD_SCORE input');
		stars.forEach(star => {
			if (star.checked) data.REVIEW_GOOD_SCORE = star.value;
		});
		let marks = document.querySelectorAll('#REVIEW_GOOD_POSITIVE input');
		marks.forEach(mark => {
			if (mark.checked) data.REVIEW_GOOD_POSITIVE = mark.value;
		});

		if (dataRequire.name === '') {
			this.showError(document.querySelector('#REVIEW_GOOD_NAME'));
			error = true;
		}

		if (dataRequire.comment === '') {
			this.showError(document.querySelector('#REVIEW_GOOD_COMMENT'));
			error = true;
		}

		if (!dataRequire.check) {
			this.showError(document.querySelector('.review-form__row-confirm input'));
			error = true;
		}

		if (error) return false;
		data.REVIEW_GOOD_ID = document.querySelector('#REVIEW_GOOD_ID').value;
		data.REVIEW_GOOD_DATE = document.querySelector('#REVIEW_GOOD_DATE').value;
		data.REVIEW_GOOD_NAME = document.querySelector('#REVIEW_GOOD_NAME').value;
		data.REVIEW_GOOD_TITLE = document.querySelector('#REVIEW_GOOD_TITLE').value;
		data.REVIEW_GOOD_ADVANTAGES = document.querySelector('#REVIEW_GOOD_ADVANTAGES').value;
		data.REVIEW_GOOD_DISADVANTAGES = document.querySelector('#REVIEW_GOOD_DISADVANTAGES').value;
		data.REVIEW_GOOD_COMMENT = document.querySelector('#REVIEW_GOOD_COMMENT').value;
		data.REVIEW_GOOD_GOOD_NAME = document.querySelector('#REVIEW_GOOD_GOOD_NAME').value;

		return data;
	},

	sendData: function (event) {
		let data = window.k1ScriptComments.getData(event);
		if (!data) return false;
		let url = '/ajax/add_comment_goods.php';

		fetch(url, {
			method: 'post',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data),

		}).then(resolve => {
			if (!resolve.ok) {
				console.log('Ошибка: ', resolve.status);
				return false
			} else {
				this.cleanForm();
				this.showSuccessModal("success-review-modal-js");
			}

		})
	},

	showSuccessModal: function (className) {
		let modal = document.querySelector(`.${className}`);
		modal.style.display = 'block';
		let timeToHide = 8000;
		document.querySelector('body').style.overflow = 'hidden';
		this.setCounterInSuccessModal(timeToHide / 1000, className);
		this.hideForm();
	},

	setCounterInSuccessModal: function (seconds, className) {
		let counterElement = document.querySelector('.success-review-modal__counter span');
		let interval = setInterval(() => {
			if (!seconds) {
				this.hideSuccessModal(className);
				clearInterval(interval);
			}
			counterElement.textContent = seconds;
			seconds--;
		}, 1000)
	},

	hideSuccessModal: function (className) {
		let modal = document.querySelector(`.${className}`);
		modal.style.display = 'none';
		document.querySelector('body').style.overflow = 'auto';
	},

	hideForm: function () {
		document.querySelector('.new-review-js').style.display = 'none';
		document.querySelector('body').style.overflow = 'auto';
	},

	cleanForm: function () {
		let inputs = document.querySelectorAll('.element-reviews__place');
		inputs.forEach(input => {
			input.value = ''
		})
	},

	setMark: function (event) {
		let mark = event.target;
		let infoText = document.querySelector('.show-rating-in-add-comments');
		infoText.textContent = mark.getAttribute('title');
		infoText.style.display = 'block';
	},

	hideMark: function () {
		let stars = document.querySelectorAll('.element-reviews__score input[type=radio]');
		let check = [...stars].filter(star => star.checked);
		if (check.length) document.querySelector('.show-rating-in-add-comments').style.display = 'none';
	},

	showError: function (input) {
		switch (input.type) {
			case 'checkbox':
				input.closest('.element-reviews__row').querySelector('label').classList.add('k1-error');
				break;
			case 'textarea':
				input.classList.add('k1-error');
				break;
			default:
				input.classList.add('k1-error');
				break;
		}
	},

	hideError: function (input) {
		input.classList.remove('k1-error');
	},

	getHeightNewReview: function () {
		return document.querySelector('.new-review-js .element-reviews__new-review').clientHeight;
	},

	showNewReview: function (button) {
		let promise = new Promise((resolve, reject) => {
			button.style.opacity = 0;
			setTimeout(() => {
				resolve(true)
			}, 100)
		});
		promise.then(bool => {
			if (bool) {
				document.querySelector('.new-review-js').style.maxHeight = this.getHeightNewReview() + 'px';
				// button.remove();
			}
		})

	},

	closeNewReview: function (button) {
		button.closest('.element-reviews').querySelector('.show-new-review-js').style.opacity = 1;
		document.querySelector('.new-review-js').style.maxHeight = '0px';
		this.cleanForm();

	},

	getAllReviews: function () {
		return {
			all: document.querySelectorAll('.product__reviews-item'),
			show: document.querySelectorAll('.product__reviews-item.show'),
		}
	},

	hideShowMoreButton: function (obj) {
		let button = document.querySelector('.show-more-review-js');
		if (button){
			if (obj.all.length === obj.show.length) {
				button.style.display = 'none'
			} else {
				button.style.display = 'flex'
			}
		}
	},

	showMoreReviews: function () {
		let obj = this.getAllReviews();
		let reviews = [...obj.all];
		let reviewsShowed = [...obj.show];
		let lastIndex = reviews.lastIndexOf(reviewsShowed[reviewsShowed.length - 1]);
		const countOfShowReviews = 5;
		for (let i = lastIndex + 1; i < reviews.length; i++) {
			if (i > 0 && i % countOfShowReviews === 0 && i !== lastIndex + 1) break;
			reviews[i].classList.add('show');
		}
		this.hideShowMoreButton(this.getAllReviews())
	},

	hideAllReviews: function (obj, click = false) {
		if (!obj.all.length) return false;
		obj.all.forEach(elem => elem.classList.remove('show'));
		obj.all[0].classList.add('show');
		this.hideShowMoreButton(this.getAllReviews());
		if (click) {
			document.querySelector('.element-main__reviews').scrollIntoView({
				behavior: "smooth"
			});
		}

	},

	init: function () {
		this.hideMark();
		this.hideAllReviews(window.k1ScriptComments.getAllReviews())
	},

};

window.addEventListener('click', function (e) {
	if (e.target.closest('#add-review')) window.k1ScriptComments.sendData(e);
	if (e.target.closest('.element-reviews__score label')) window.k1ScriptComments.setMark(e);
	if (e.target.closest('.show-new-review-js')) window.k1ScriptComments.showNewReview(e.target);
	if (e.target.closest('.send-review__cancel')) window.k1ScriptComments.closeNewReview(e.target);

	if (e.target.closest('.show-more-review-js')) window.k1ScriptComments.showMoreReviews();
	if (e.target.closest('.hide-review-js')) window.k1ScriptComments.hideAllReviews(window.k1ScriptComments.getAllReviews(), true);
});


window.addEventListener('input', e => {
	if (e.target.closest('.element-reviews__place.k1-error')) window.k1ScriptComments.hideError(e.target.closest('.element-reviews__place.k1-error'))
});

window.addEventListener('DOMContentLoaded', function () {
	window.k1ScriptComments.init();
})
